// extracted by mini-css-extract-plugin
module.exports = {"seriesListWrapper":"pf","fullWidth":"ph","seriesListTabWrapper":"pi","tab":"pj","active":"pk"};